import { useReveal } from '../hooks/useReveal';
import MaterialIcon from './MaterialIcon';
import IdeCodePanel from './code/IdeCodePanel';

const cards = [
  {
    title: 'For enterprises',
    body:
      'Move with clarity and speed: modernization, new product lanes, and platforms that respect your goals and governance.',
    icon: 'business',
    variant: 'drift',
  },
  {
    title: 'For partners',
    body:
      'Strategic collaboration—not just staffing. We align on outcomes, simplify complexity, and deliver with precision.',
    icon: 'groups',
    variant: 'pulse',
  },
  {
    title: 'For people who use the product',
    body:
      'Tools that feel natural: fewer sharp edges, clearer flows, and interfaces built around real work—not feature bloat.',
    icon: 'touch_app',
    variant: 'float',
  },
];

export default function Audiences() {
  const [ref, visible] = useReveal();

  return (
    <section id="clients" className="ca-section ca-section--alt" ref={ref} data-analytics-section="clients">
      <div className="ca-container">
        <header className={`ca-section-head ca-reveal ${visible ? 'ca-reveal--visible' : ''}`}>
          <p className="ca-eyebrow">Who we serve</p>
          <h2 className="ca-section-title">Built for every side of the journey</h2>
          <p className="ca-section-lead">
            Investors see leverage. Clients see trust. Users see simplicity. We design for all three.
          </p>
        </header>

        <IdeCodePanel
          variant="deploy"
          caption="Every merge is traceable—CI, previews, and production pushes with clear audit trails for your teams."
        />

        <ul className="ca-audience-grid">
          {cards.map((c, i) => (
            <li
              key={c.title}
              className={`ca-audience ca-reveal ${visible ? 'ca-reveal--visible' : ''}`}
              style={{ transitionDelay: `${100 + i * 90}ms` }}
            >
              <span className="ca-audience__icon">
                <MaterialIcon name={c.icon} variant={c.variant} />
              </span>
              <h3 className="ca-audience__title">{c.title}</h3>
              <p className="ca-audience__body">{c.body}</p>
            </li>
          ))}
        </ul>
      </div>
    </section>
  );
}
